<template>
  <div class="mt-2 mx-sm-1  mx-lg-3">
    <swiper
      ref="swiperof"
      class="swiper"
      :options="swiperOption"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    >
      <swiper-slide
        v-for="(data,index) in ofertaAcademica"
        :key="`swslide-oferta-${index}`"
      >
        <div class=" card-deck  h-100">
          <div class="card">
            <b-card
              no-body
            >
              <div class="fondo rounded mt-1">
                <b-card-title class="m-3">
                  <b><em>{{ data.nombre }}</em></b>
                  <br>
                  <small>{{ data.nombre_division }}</small>
                  <br>
                </b-card-title>
              </div>
              <b-card-body>
                <p class="text-justify m-1">
                  {{ data.descripcion }}
                </p>
                <!-- media -->
                <media-avatar
                  v-if="coordinador"
                  :data="coordinador.filter(({ plan }) => plan === data.id)"
                  :titulo="'Coordinador'"
                  :idm="'modal'"
                />
                <media-avatar
                  v-if="asesor"
                  :data="asesor.filter(({ plan }) => plan === data.id)"
                  :titulo="'Responsables de asignaturas'"
                  :idm="'modal'"
                />
              </b-card-body>
              <modal-perfil
                v-if="asesor"
                :data="asesor.filter(({ plan }) => plan === data.id)"
                :idm="'modal'"
              />
              <modal-perfil
                v-if="coordinador"
                style="position: absolute;"
                :data="coordinador.filter(({ plan }) => plan === data.id)"
                :idm="'modal'"
              />
              <br>
              <div class="card-footer">

                <div class="text-right">
                  <em>Fecha de Inicio : {{ `${data.calendario.length ? timestampToDate(getCalendarDates(data.calendario, 3).fechaIni) : 'Próximamente'}` }} - </em>
                  <b-button
                    :to="`/detalle-especialidad/${data.id}`"
                    variant="primary"
                  >
                    Detalles
                  </b-button>
                </div>

              </div>
            </b-card>
          </div>
        </div>
      </swiper-slide>

    </swiper>
    <b-container>
      <b-row class="m-4">
        <b-col class="text-right d-none d-lg-block">
          <b-button
            size="sm"
            variant="outline-primary"
            pill
            @click="anterior()"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              size="12"
            />
            <small class="ml-2 align-middle">Anterior</small>
          </b-button>
        </b-col>
        <b-col class="text-center">
          <b-pagination-nav
            v-model="currentPage"
            :link-gen="linkGen"
            pills
            size="sm"
            :number-of-pages="numberOfPages"
            base-url="#"
            align="center"
            @page-click="onPageClick"
          />
        </b-col>
        <b-col class="text-left d-none d-lg-block">
          <b-button
            size="sm"
            variant="outline-primary"
            pill
            @click="siguiente()"
          >
            <small class="mr-2 align-middle">Siguiente</small>
            <feather-icon
              icon="ArrowRightIcon"
              size="12"
            />
          </b-button>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>
<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BCard, BButton, BCol, BRow, BContainer, BPaginationNav,
  BCardBody, BCardTitle,
} from 'bootstrap-vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { timestampToDate } from '@core/utils/filter'
import {
  ref, onMounted, computed, getCurrentInstance, onBeforeUnmount,
} from '@vue/composition-api'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'swiper/swiper.min.css'
import store from '@/store'
import { $themeConfig } from '@themeConfig'
import { useToast } from 'vue-toastification/composition'
import ModalPerfil from './modal-card-academica.vue'
import MediaAvatar from './media-avatar-academica.vue'

export default {
  components: {
    BCard,
    BCol,
    Swiper,
    SwiperSlide,
    BButton,
    BRow,
    BContainer,
    BPaginationNav,
    BCardBody,
    BCardTitle,
    ModalPerfil,
    MediaAvatar,
  },
  props: {
    asesor: {
      type: [Array, null],
      default: null,
    },
    coordinador: {
      type: [Array, null],
      default: null,
    },
  },
  setup() {
    const { appLogoImage } = $themeConfig.app
    const swiperOption = ref({
      slidesPerView: 2,
      slidesPerColumn: 1,
      spaceBetween: 40,
      lazy: true,
      // centeredSlides: true,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        340: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    })

    const vm = getCurrentInstance().proxy
    // filtramos los de tipo curso para no mostrarlos
    const ofertaAcademica = computed(() => store.state.ofertaAcademica.especialidadesPublicas.filter(e => e.nivel_id !== 1))
    const currentPage = ref(1)
    const numberOfPages = ref(1)
    const numeroElementos = computed(() => ofertaAcademica.value.length)
    const linkGen = () => ''
    const onPageClick = (event, page) => {
      vm.$refs.swiperof.swiperInstance.slideTo(page - 1, 1000, false)
      currentPage.value = page
    }
    const siguiente = () => {
      vm.$refs.swiperof.swiperInstance.slideNext()
      if (currentPage.value < numberOfPages.value) currentPage.value += 1
      // else currentPage.value = 1
    }

    const anterior = () => {
      vm.$refs.swiperof.swiperInstance.slidePrev()
      if (currentPage.value > 1) currentPage.value -= 1
      // else currentPage.value = numberOfPages.value
    }
    const loader = {
      planEstudios: false,
    }
    const toast = useToast()
    const getplanEstudios = () => {
      loader.planEstudios = true
      store.dispatch('ofertaAcademica/loadOfertaPublica')
        .then(() => {
          loader.planEstudios = false
        }, error => {
          loader.planEstudios = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando oferta académica',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
    }
    const getCalendarDates = (arry, type) => arry.find(item => item.tipo === parseInt(type, 10))
    const setNumeroPaginas = () => {
      const bpsw = vm.$refs.swiperof.swiperInstance?.currentBreakpoint
      const slidesPerView = swiperOption.value.breakpoints[bpsw] ? swiperOption.value.breakpoints[bpsw].slidesPerView : 1
      numberOfPages.value = (numeroElementos.value / slidesPerView) > 1 ? (numeroElementos.value - (slidesPerView - 1)) : 1
    }

    const handleResize = () => {
      setNumeroPaginas()
    }
    onMounted(() => {
      getplanEstudios()
      setNumeroPaginas()
      window.addEventListener('resize', handleResize)
    })
    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize)
    })
    // vm.$refs.swiperof
    return {
      getCalendarDates,
      ofertaAcademica,
      swiperOption,
      timestampToDate,
      currentPage,
      numberOfPages,
      linkGen,
      onPageClick,
      siguiente,
      anterior,
      appLogoImage,
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-sweetalert.scss';
.profile-image img {
    width: 130px !important;
    height: 130px !important;
}
.fondo {
  background-color: rgb(232 232 232);
}
.card-footer{
  position:absolute;
  bottom:0;
  width: 100%;
}
.card-deck .card{
  padding-bottom: 50px;
  }
</style>
